export const BRAND_BLUE = '#00486A';
export const BRAND_DARK = '#002644';
export const TEXT_DARK = '#2d2d2d';
export const TEXT_BODY = '#333333';
export const ROW_ALT = '#f0f0ef';
export const TABLE_HEADER_LIGHT = '#E5E5E4';
export const ACCENT_ORANGE = '#FFC040';
export const ACCENT_RED = '#FF4646';
export const ACCENT_BROWN = '#aa4400';
export const FONT_FAMILY = 'Verdana, Arial, Helvetica, sans-serif';

/** Repli si manifest.json absent (généré par scripts/generate-csv-manifest.mjs). */
export const CSV_TEAMS_PATH = '/csv/New_Resequipes13102026.CSV';
export const CSV_INDIVIDUALS_PATH = '/csv/New_Resindividuels13102026.CSV';
export const CSV_MANIFEST_PATH = '/csv/manifest.json';

export const DEFAULT_YEAR = 2026;

export const OFFICIAL_SITE = 'https://quillesdehuit.org';
/** Ancien lien « Retour site officiel » (résultats équipes RWD) — conserver pour bascule rapide. */
export const OFFICIAL_TEAM_RESULTS_URL_LEGACY = `${OFFICIAL_SITE}/Resultat-par-equipe-rwd.awp`;
/** Retour site officiel — accueil national. */
export const OFFICIAL_TEAM_RESULTS_URL = `${OFFICIAL_SITE}/accueil-quilles-de-huit.awp`;
/** Résultats individuels complets (filtres zone / championnat dédiés) — hors clone équipes. */
export const OFFICIAL_INDIVIDUAL_RESULTS_URL = `${OFFICIAL_SITE}/resultat-individuel-rwd.awp`;

/** Extrait l'année de saison (AAAA) d'un nom …DDMMYYYY.CSV (JJMM = date MAJ CS12). */
export function extractYearFromCsvPath(path) {
	const match = path.match(/(\d{2})(\d{2})(\d{4})\.CSV$/i);
	return match ? Number(match[3]) : null;
}

/** Clé de tri AAAAMMJJ pour comparer deux dates de mise à jour dans le nom. */
export function extractUpdateSortKeyFromCsvPath(path) {
	const match = path.match(/(\d{2})(\d{2})(\d{4})\.CSV$/i);
	if (!match) return null;
	const day = Number(match[1]);
	const month = Number(match[2]);
	const year = Number(match[3]);
	return year * 10000 + month * 100 + day;
}

export const LEGEND_ITEMS = [
	'M1 à M4 : Plateaux Ecoles de Quilles Aveyron',
	'M1 à M8 : Championnats par équipes Aveyron, Hérault, Paris',
	'M5 : Finale par équipes écoles de quilles Aveyron',
	'M6 : Finale individuelle écoles de quilles Aveyron',
	'M9 : Coupes de l\'Aveyron',
	'M10 à M11 : Championnats individuels Aveyron, Grand Sud et Paris',
	'M12 à M13 : Championnats individuels de Districts Aveyron',
	'M14 à M15 : Challenge National Ecoles de Quilles par équipes',
	'M14 à M15 : Championnat de France par Equipes',
	'M16 à M17 : Challenge National des Ecoles de Quilles Individuel',
	'M16 à M17 : Championnat de France Individuel',
	'M20 à M24 : Championnat Midi-Pyrénées par équipes',
	'M25 à M28 : Challenge Ségala Garonne',
];
